import { h } from '@stencil/core';
import { i18n } from 'i18n';
import { triggerTrackEvent } from 'utils/events';
import tripPlanner from 'store/tripPlanner';

export default function ItineraryMapModal({ show }: { show: boolean }) {
  const onClose = () => {
    triggerTrackEvent({
      event_type: 'user',
      event_name: `itinerary_map_modal_close`,
    });
    tripPlanner.showModal = null;
  };

  return show ? (
    <div id="itinerary-map-modal" role="presentation" class="eva-3-modal-side-sheet fullscreen-modal -show-modal-side-sheet -white -md -right -close-on-left">
      <div class="sheet-container">
        <div class="sheet-header" role="presentation">
          <i class="eva-3-icon-cross modal-close -eva-3-mr-md -eva-3-hide-small" role="button" aria-label={i18n.t.itineraryMapModal.close} onClick={onClose}></i>
          <i class="eva-3-icon-arrow-bold-left modal-close -eva-3-mr-md -eva-3-hide-medium-up" role="button" aria-label={i18n.t.itineraryMapModal.close} onClick={onClose}></i>

          <div class="sheet-title">
            <h4 class="eva-3-h4">{i18n.t.itineraryMapModal.title}</h4>
          </div>
        </div>
        <div class="sheet-content" role="presentation">
          <div class="map-container h100">
            <chat-itinerary-map data-model={JSON.stringify(tripPlanner.days)} />
          </div>
        </div>
      </div>
    </div>
  ) : null;
}
